import { ManagementApiService } from 'src/app/services';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import jwt_decode from 'jwt-decode';
import { map, take } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class AdminGuradGuard implements CanActivate {
    decodedData: any;
    constructor(
        private managementApiService: ManagementApiService,
        private router: Router
    ) {}
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        let token = localStorage.getItem('msal.accessToken');
        this.decodedData = jwt_decode(token);

        //Added new guard according to Check Super Admin for Ice Database.
        return this.managementApiService.getFullUserDetail(this.decodedData.oid).pipe(
            take(1),
            map((response) => {
                if (
                    response.response?.isSysAdmin &&
                    response.response?.license.isValid &&
                    (response.response?.license.instanceTypeIndex == 1 || response.response?.license.instanceTypeIndex == 3)
                ) {
                    return true;
                } else {
                    this.router.navigate(['/401']);
                    return false;
                }
            })
        );
    }
}
